import React, { useMemo } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { floatToPercentageString } from '../../utils/DataFormatterUtils';
import { compareStrings } from '../../utils/DataAccessUtils';

const getKPIColor = (val, baseline) => {
	if (val === null || val === undefined) {
		return 'rgba(0,0,0,0.45)';
	} else if (val >= baseline) {
		return 'green';
	} else {
		return 'red';
	}
};

const getReverseKPIColor = (val, baseline) => {
	if (val === null || val === undefined) {
		return 'rgba(0,0,0,0.45)';
	} else if (val >= baseline) {
		return 'red';
	} else {
		return 'green';
	}
};

const getTrendIndicator = (percentageChange) => {
	return percentageChange >= 0 ? (
		<i className="icons8-font icons8-up"></i>
	) : (
		<i className="icons8-font icons8-down-arrow"></i>
	);
};

const formatPercentChange = (type, valueChange) => {
	switch (type) {
		case 'rate':
			return floatToPercentageString(Math.abs(valueChange), 0);
		default:
			return floatToPercentageString(Math.abs(valueChange), 0);
	}
};

const DashboardValueChangeDisplay = ({
	endDate,
	startDate,
	value,
	pastValue,
	kpi,
}): React.ReactElement => {
	const { type, color } = kpi;

	const valueChange = useMemo(
		() =>
			value && pastValue
				? type === 'rate'
					? value - pastValue
					: (value - pastValue) / pastValue
				: undefined,
		[value, pastValue]
	);

	return startDate && endDate ? (
		<div
			style={{
				fontSize: 16,
				fontWeight: 300,
			}}
		>
			{valueChange !== 0 && valueChange !== undefined ? (
				[
					<span
						style={{
							color:
								color === 'reverse'
									? getReverseKPIColor(valueChange, 0)
									: getKPIColor(valueChange, 0),
						}}
					>
						{getTrendIndicator(valueChange)}
						{formatPercentChange(type, valueChange)}
					</span>,
					<span
						style={{
							fontSize: 14,
							color: 'rgba(0, 0, 0, 0.45)',
						}}
					>
						{valueChange >= 0 ? ' increase ' : ' decrease '}
						{` over `}
						{moment.duration(moment(endDate).diff(moment(startDate))).humanize()} {' ago'}
					</span>,
				]
			) : valueChange === 0 || (value === 0 && pastValue === 0) ? (
				<span
					style={{
						fontSize: 14,
						color: 'rgba(0, 0, 0, 0.45)',
					}}
				>
					{`No change over `}
					{moment.duration(moment(endDate).diff(moment(startDate))).humanize()}
					{' ago'}
				</span>
			) : (
				[
					<span
						style={{
							color:
								color === 'reverse'
									? getReverseKPIColor(value - pastValue, 0)
									: getKPIColor(value - pastValue, 0),
						}}
					>
						{value - pastValue > 0 ? '+' : null}
						{compareStrings(kpi.type, 'time')
							? moment.duration(value - pastValue, 'seconds').humanize()
							: value - pastValue}
					</span>,
					<span style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.45)' }}>
						{value - pastValue > 0 ? ` increase ` : ` decrease `}
						{`over `}
						{moment.duration(moment(endDate).diff(moment(startDate))).humanize()}
						{' ago'}
					</span>,
				]
			)}
		</div>
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	attentionDashboard: state.attention_dashboards.detail,
});

const mapDispatchToProps = (dispatch) => ({
	getCount: (fn) => dispatch(fn),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardValueChangeDisplay);
